
import { AddCircle } from "@mui/icons-material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { OrganisationContext } from "./Layout/OrganisationPicker";
import DrawerButton from "./DrawerButton";

export interface CreateEntityButtonProps {
    children?: any
    tooltip?: string
    ignoreOrganisationContext?: boolean
    open: boolean
    setOpen: (open: boolean) => void
    onClose?: () => void
    buttonIcon?: JSX.Element
    disabled?: boolean
}

export const CreateEntityButton = (props: CreateEntityButtonProps) => {
    const { t } = useTranslation()
    const currentOrganisation = useContext(OrganisationContext)?.organisation;
    const allowCreation = props.ignoreOrganisationContext == undefined ? currentOrganisation != undefined : props.ignoreOrganisationContext;

    return (
        <DrawerButton
            tooltip={allowCreation ? (props.tooltip ? t(props.tooltip) + "" : "") : t("Select an organisation to create")}
            onClose={props.onClose}
            open={props.open}
            setOpen={props.setOpen}
            disabled={props.disabled ? props.disabled : !allowCreation}
            buttonContent={props.buttonIcon ?? <AddCircle />}
        >
            {props.children}
        </DrawerButton>

    )
}